export default {
    computed: {
        permissions() {
            return this.$store.getters.dealPermissions;
        }
    },
    methods: {
        canField(editMode, field, statusId = null) {
            let result = this.permissions.filter(item => item.includes('deal_')).filter(item => item.includes(field));
            if (editMode) {
                result = result.filter(item => item.includes(`deal_edit_${field}`));
            }
            if (statusId) {
                if (editMode) {
                    if (result.indexOf(`deal_edit_${field}_status_${statusId}`) !== -1) {
                        return true;
                    }
                    return result.indexOf(`deal_edit_${field}_status_other`) !== -1;
                } else {
                    if (result.indexOf(`deal_view_${field}_status_${statusId}`) !== -1) {
                        return true;
                    }
                    return result.indexOf(`deal_view_${field}_status_other`) !== -1;
                }
            }
            return result.length > 0;
        },
        canViewField(field, statusId = null) {
            const result = this.permissions.filter(item => item.includes('deal_')).filter(item => item.includes(field));
            if (statusId) {
                /*
                 * Если есть статус, ищем по его ид, если не находим ищеи разрешения для прочих статусов
                 */
                if (result.indexOf(`deal_edit_${field}_status_${statusId}`) !== -1 || result.indexOf(`deal_view_${field}_status_${statusId}`) !== -1) {
                    return true;
                }
                return result.indexOf(`deal_edit_${field}_status_other`) !== -1 || result.indexOf(`deal_view_${field}_status_other`) !== -1;
            }
            return result.length > 0;
        },
        canEditField(field, statusId = null) {
            const result = this.permissions.filter(item => item.includes(`deal_edit_${field}`));
            if (statusId) {
                /*
                 * Если есть статус, ищем по его ид, если не находим ищеи разрешения для прочих статусов
                 */
                if (result.indexOf(`deal_edit_${field}_status_${statusId}`) !== -1) {
                    return true;
                } else {
                    return result.indexOf(`deal_edit_${field}_status_other`) !== -1;
                }
            }
            return result.length > 0;
        },
        canEditContactField(editMode) {
            const approvedRoles = this.$store.getters['references/rolesBySectionContacts'];
            const userRoles = this.$store.state.auth.roles;
            if (editMode) {
                if (this.permissions.filter(item => item.includes('deal_edit_contact_id')).length > 0) {
                    return true;
                }
                if (approvedRoles.indexOf('companies_read') !== -1) {
                    approvedRoles.splice(approvedRoles.indexOf('companies_read'), 1);
                }
                return Object.keys(userRoles).filter(role => approvedRoles.includes(role)).length > 0;
            }
            return Object.keys(userRoles).filter(role => approvedRoles.includes(role)).length > 0;
        }
    }
};
